import {MouseEvent} from 'react';

import {isNotNil} from 'ramda';
import {isNilOrEmpty} from 'ramda-adjunct';

import {Nullish} from 'shared/web';

import {isUnifiedSourcingEnabled} from '../utils/isUnifiedSourcingEnabled';
import {useOpenVehicleDetail} from './useOpenVehicleDetail';

const INTERACTIVE_TARGET_SELECTOR = [
  'button',
  'a',
  'input',
  'label',
  'select',
  'textarea',
  '[contenteditable]',
  ...[
    'button',
    'checkbox',
    'switch',
    'combobox',
    'menuitem',
    'tab',
    'option',
    'slider',
    'textbox',
  ].map((role) => `[role="${role}"]`),
].join(', ');

export function useVehicleDoubleClick(adId: string | Nullish, onDetailOpen?: () => void) {
  const {openDetail} = useOpenVehicleDetail(adId, onDetailOpen);

  return (event: MouseEvent<HTMLElement>) => {
    if (!isUnifiedSourcingEnabled() || !(event.target instanceof Element)) {
      return;
    }
    const interactiveTarget = event.target.closest(INTERACTIVE_TARGET_SELECTOR);
    // Controls inside a card keep their own double-click behavior.
    if (
      isNilOrEmpty(adId) ||
      !event.currentTarget.contains(event.target) ||
      (isNotNil(interactiveTarget) && event.currentTarget.contains(interactiveTarget))
    ) {
      return;
    }

    openDetail();
  };
}
